import {Component, EventEmitter,ViewEncapsulation,Input,Output  } from '@angular/core';

@Component({
  selector: 'ngbd-modal-sectionpopup',
  templateUrl: './modal-sectionpopup.html'
})
export class NgbdModalSectionPopup {
	/*@Input() activeFieldTabType;
	@Input() fieldTabArray;
	@Output() AddMoreOptionsFInsideTab = new EventEmitter();
	@Output() AddOptionsFieldInsideTabs = new EventEmitter();*/
	@Output() close_TabSectionPopup = new EventEmitter();
  constructor() {
	
  }
  
  /*AddMoreOptionsFInside(h){
	this.AddMoreOptionsFInsideTab.emit(h);
  }
  AddOptionsFieldInsideTab(){
	this.AddOptionsFieldInsideTabs.emit();
  } */
  close_pop(){
	this.close_TabSectionPopup.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/create/modal-sectionpopup.ts